<template>
  <div class="animated fadeIn">
    <CCard>
      <CCardHeader>
        <strong>New Category</strong>
      </CCardHeader>
      <CCardBody>
        <CRow class="mt-3">
          <CCol sm="4">
            <CInput label="User Name" v-model="reward_data.user.name" disabled/>
          </CCol>
          <CCol sm="4">
            <CInput label="Phone Number" v-model="reward_data.msisdn" disabled/>
          </CCol>
          <CCol sm="4">
            <CInput label="Amount" v-model="reward_data.amount" disabled/>
          </CCol>
        </CRow>
        <CRow class="mt-3">
          <CCol sm="4">
            <CInput label="Type" v-model="reward_data.type" disabled/>
          </CCol>
          <CCol sm="4">
            <CInput label="Gratification Type" v-model="reward_data.gratification_type" disabled/>
          </CCol>
          <CCol sm="4" v-if="reward_data.tournament">
            <CInput label="Tournament Name" v-model="reward_data.tournament.name" disabled/>
          </CCol>
        </CRow>
        <CRow class="mt-3">
          <CCol sm="4">
            <CInput label="Type" v-model="reward_data.connection_type" disabled/>
          </CCol>
        </CRow>

      </CCardBody>
      <CCardFooter>

        <div class="cardheading">
          <h4><i class="fa  fa-paper-plane"></i><span class="ml-1">Send Reward</span></h4>
          <!-- decision of whether to send data/recharge manually -->
          <div v-if="reward_data.is_recharge_completed == '1' ">
            <div class="alert alert-warning" role="alert">
              This user has been awarded successfully.
            </div>
          </div>
          <!-- View to send data/ recharge -->
          <div v-else>

            <CRow class="mt-12">
              <CCol sm="12">
                <label>Select Gratification Type</label>
                <CSelect
                    :options="['DATA', 'RECHARGE']"
                    size="lg"
                    :value.sync="reward_data.type"
                />
              </CCol>

              <CCol sm="6">
                <label>Select Operator</label>
                <CSelect
                    :options="['GP', 'BL', 'RB', 'AT', 'TT',
                      // 'GP ST'
                      ]"
                    size="lg"
                    :value.sync="reward_data.operator_short"
                />
              </CCol>

            </CRow>

            <div class="alert alert-warning" role="alert">
              the type is {{reward_data.type}}
            </div>

            <div class="alert alert-warning" role="alert">
              the operator is {{reward_data.operator_short}}
            </div>

            <button v-on:click="sendRewardApi" type="button" class="btn btn-square btn-dark">Send Reward</button>

            <!--          <button v-on:change="send_status" type="button" class="btn btn-square btn-dark">{{ send_status }}</button>-->

          </div>
        </div>
        <!--          <CButton @click="" color="primary"-->
        <!--          ><CIcon name="cil-check-circle" /> Add Category</CButton-->
        <!--          >-->
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default {
  name: "SendGratification",

  data() {
    return {
      type: "",
      operator: "",
      reward_data: [],
      already_send: "",
      payload: [],
      send_status: "",
      date: new Date(),
      options: {
        pagination: { nav: "fixed" },
        filterByColumn: true,
        dateColumns: ["created_at"],
        //dateFormat: 'DD-MM-YYYY',
        toMomentFormat: true,
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      this.balance = id;

      axios.get(`${ADMIN_URL}/recharge-data-single/${id}`)
          .then(response => {

            if(response.data.success == true){
              this.reward_data = response.data.row;
              // this.alreadyRewarded();
            }
          }).catch(error => {
        //console.log('Error. .. .', error.response);
        const errResponse = error.response;
        if (errResponse.status === 404) {
          this.user_notfound = true;
        }
      })

    },
    // alreadyRewarded(){
    //   const phone=this.reward_data.phone;
    //   console.log('alreadyRewarded url ', `${ADMIN_URL}/recharge-data-taken-reward/${phone}`);
    //   axios.get(`${ADMIN_URL}/recharge-data-taken-reward/${phone}`)
    //       .then(response => {
    //         //console.log('Response  ', response.data);
    //         this.already_send=response.data.already_rewarded;
    //
    //       }).catch(error => {
    //     //console.log('Error. .. .', error.response);
    //     const errResponse = error.response;
    //     if (errResponse.status === 404) {
    //       this.user_notfound = true;
    //     }
    //   })
    //
    // },
    sendRewardApi(){
      const payload = {
        type: this.reward_data.type,
        operator: this.reward_data.operator_short,
        id: this.reward_data.id
      };

      axios.post(`${ADMIN_URL}/recharge-data-send-reward/`, payload)
          .then(response => {
            console.log('Response send reward  ', response.data);
            if(response.data.success == true){
              this.$swal("Result", response.data.message, "success");
            }else{
              this.$swal("Result", response.data.message, "warning");
            }
          }).catch(error => {
        //console.log('Error. .. .', error.response);
        const errResponse = error.response;
        if (errResponse.status === 404) {
          this.user_notfound = true;
          console.log('Response send reward fail ', response.data);
        }
      })
    },


  }
}
</script>

<style scoped>

</style>
